import { isValidPhoneNumber } from 'react-phone-number-input';
export const phoneValidator = [
    (value) => {
        return isValidPhoneNumber(value);
    },
    { message: 'Le numéro de téléphone est invalide' },
];
